module.exports = __webpack_public_path__ + "static/media/linux.dcc66bfe.svg";